import * as t from 'io-ts';

import {
  RAnalyticsColumnNamesDirty,
  RAnalyticsExportsDirty,
} from '../../../../models/api/analyticsExportModel';

/*
 * Runtime types.
 */

export const RAnalyticsPanelExportsStateDirty = t.type({
  isFetchingColumnNames: t.boolean,
  columnNames: RAnalyticsColumnNamesDirty,
  isFetchingEventTypes: t.boolean,
  eventTypes: t.readonlyArray(t.string),
  exports: RAnalyticsExportsDirty,
  isFetchingExports: t.boolean,
});

/*
 * Types.
 */

export interface AnalyticsPanelExportsState
  extends Readonly<t.TypeOf<typeof RAnalyticsPanelExportsStateDirty>> {}
